import React from 'react';
import { useMediaQuery } from '@mui/material';
import AppBarComponent from './Parts/appBarComponent';
import AppBarComponentDTP from './Parts/appBarComponentDesktop';

const AppBarComponentConditional = (props) => {
    // Check if the screen width is greater than 600px
    const isDesktop = useMediaQuery('(min-width:600px)');

    const {
        pageInfo,
        drawerVariantValue,
        userMenu,
        setContentWidth
    } = props;

    return isDesktop ? (
        <AppBarComponentDTP
            pageInfo={pageInfo}
            drawerVariant={{ drawerVariantValue }}
            {...pageInfo?.appbar}
            userMenu={userMenu}
            setWidthFunc={setContentWidth}
        />
    ) : (
        <AppBarComponent
            pageInfo={pageInfo}
            drawerVariant={{ drawerVariantValue }}
            {...pageInfo?.appbar}
            userMenu={userMenu}
            setWidthFunc={setContentWidth}
        />
    );
};

export default AppBarComponentConditional;
